import { createRouter, createWebHistory } from "vue-router"
import { createRouteItem, generateResourceRoutes } from "~/logic/route.logic"

import AuthRoute from "./auth.router"
import ManagerRoute from "./manager.router"
import AdminRoute from "./admin.router"
import SpaceRoute from "./space.router"

import AuthLayout from "~/components/layout/AuthLayout.vue"
import ManagerLayout from "~/components/layout/ManagerLayout.vue"
import AdminLayout from "~/components/layout/AdminLayout.vue"
import SpaceLayout from "~/components/layout/SpaceLayout.vue"
import { AutMiddleware } from "~/middleware/auth.middleware"

const modules = import.meta.glob("~/stores/crud/*.store.ts", { eager: true })

const resources = Object.keys(modules).map((filePath) => {
    const resourceName = filePath.split("/").pop().replace(".store.ts", "")
    const storeName = `use${resourceName.charAt(0).toUpperCase() + resourceName.slice(1)}Store`
    return {
        endpoint: resourceName.toLowerCase(),
        title: resourceName[0].toUpperCase() + resourceName.slice(1),
        store: modules[filePath][storeName],
    }
})

const dynamicRoutes = resources.flatMap(generateResourceRoutes)

const router = createRouter({
    history: createWebHistory(),
    routes: [
        createRouteItem("auth", AuthRoute, AuthLayout),
        createRouteItem("manager", ManagerRoute, ManagerLayout),
        createRouteItem("admin", AdminRoute, AdminLayout),
        createRouteItem("space", SpaceRoute, SpaceLayout),
        // Route publique de signature (sans layout)
        {
            path: "/sign/:token",
            name: "public.sign",
            component: () => import("~/pages/public/PublicSignPage.vue"),
            meta: { public: true },
        },
        // Route publique de diagnostic Lola (sans layout)
        {
            path: "/access",
            name: "public.access",
            component: () => import("~/pages/public/PublicAccessPage.vue"),
            meta: { public: true },
        },
        // Route publique d'accès Prodevis (sans layout)
        {
            path: "/access/prodevis",
            name: "public.access.prodevis",
            component: () =>
                import("~/pages/public/PublicAccessProdevisPage.vue"),
            meta: { public: true },
        },
        ...dynamicRoutes,
        // Catch-all : redirige "/" et routes inconnues vers manager home
        {
            path: "/:pathMatch(.*)*",
            name: "not-found",
            redirect: { name: "manager.dashboard" },
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
})

router.onError((error) => {
    console.error("Router error:", error)
})

router.beforeEach(AutMiddleware)

export default router
